import store from 'src/store';

import {
    showStaticContent,
//    hideContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    showPageGlobal,
//    hidePageGlobal
} from "src/shared_modules/veu-visitors-core/actions/pages";

/**
 * Generic function for footer help button and more to open static, global or exteranal content
 *
 * @param  {[type]} defobj
 *  Examples:
 *   { show: true, type: "extern", url: "https://seven-m.de" }
 *   { show: true, type: "global", id: "global-page-help" }
 *   { show: true, type: "static", url: "help.html" }
 */
export const openContentOrPageClickHandler = ( defobj ) => {
    if( defobj.type === "extern" ) {
        window.open(defobj.url, '_blank', 'noopener,noreferrer');
    } else if( defobj.type === "static" ) {
        store.dispatch(showStaticContent(defobj.url));
    } else if( defobj.type === "global" ) {
        store.dispatch(showPageGlobal(defobj.id));
    }
}
